import request from 'superagent';
import { getUserToken } from 'services/authentication';
import Config from 'app/config';

export default (filePath, fileType) => {
  return new Promise((resolve, reject) => {
    const API_HOST = Config.get('CREATE_API_HOST');
    request
      .get(`${API_HOST}/api-v3/files/aws/get-signed-url?file=${filePath}&type=${fileType}`)
      .set('Authorization', `Bearer ${getUserToken()}`)
      .end((err, res) => {
        if (err) {
          reject(err);
        } else if (res.statusCode >= 400) {
          reject(new Error(`Request completed with code ${res.statusCode}`));
        } else {
          resolve(res.body);
        }
      });
  });
};
